import { MfsLabelIdInUseError } from '@metaos/mfs-client';
import { MfsError } from '@metaos/mfs-telemetry';
import { BadRequest } from './errorClasses/badRequest';
import { BrokenPipeIssue } from './errorClasses/brokenPipeIssue';
import { ConflictError } from './errorClasses/conflictError';
import { DataCorruptionError } from './errorClasses/dataCorruptionError';
import { Forbidden } from './errorClasses/forbidden';
import { InternalServerError } from './errorClasses/internalServerError';
import { InvalidOperation } from './errorClasses/invalidOperation';
import { NotFound } from './errorClasses/notFound';
import { NotImplemented } from './errorClasses/notImplemented';
import { PayloadTooLarge } from './errorClasses/payloadTooLarge';
import { ResourceIdAlreadyInUse } from './errorClasses/resourceIdAlreadyInUse';
import { TooManyRequests } from './errorClasses/tooManyRequests';
import { Unauthorized } from './errorClasses/unauthorized';
import { UnexpectedError } from './errorClasses/unexpectedError';
/**
 * This function is responsible to handle the "catch" sections of code.
 * Usually triggered by a MfsError object, in this case will return a new object based on the HTTP Status Code of the error.
 *
 * @param message The message that will be returned to the user
 * @param error the actual error object
 * @param eventName Identification of the event that triggered the error
 */
export function mfsErrorHandler(message, error, eventName) {
    var _a;
    const errorMessage = (_a = error.message) !== null && _a !== void 0 ? _a : message;
    if (error instanceof MfsError) {
        switch (error.statusCode) {
            case 400:
                return new BadRequest(errorMessage, eventName);
            case 401:
                return new Unauthorized(errorMessage, eventName);
            case 403:
                return new Forbidden(errorMessage, eventName);
            case 404:
                return new NotFound(errorMessage, eventName);
            case 409:
                return new ConflictError(errorMessage, eventName);
            case 413:
                return new PayloadTooLarge(errorMessage, eventName);
            case 418:
                if (error instanceof MfsLabelIdInUseError) {
                    return new ResourceIdAlreadyInUse(errorMessage, eventName);
                }
                else {
                    return new InvalidOperation(errorMessage, eventName);
                }
            case 429:
                return new TooManyRequests(errorMessage, eventName);
            case 499:
                return new BrokenPipeIssue(errorMessage, eventName);
            case 500:
                return new InternalServerError(errorMessage, eventName);
            case 501:
                return new NotImplemented(errorMessage, eventName);
            case 510:
                return new DataCorruptionError(errorMessage, eventName);
        }
    }
    return new UnexpectedError(error, errorMessage, eventName);
}
/**
 * Convert a user-defined completeCallback from Folders-centric to MFS-centric.
 * @param cb completeCallback to wrap
 * @returns wrapped completeCallback
 */
export function wrapCompletedCallback(cb) {
    return (error) => {
        try {
            const foldersError = error ? mfsErrorHandler(error.message, error) : undefined;
            cb(foldersError);
        }
        catch (er) {
            // swallow errors from user defined function.
        }
    };
}
//# sourceMappingURL=mfsErrorHandler.js.map